export const typeDefs = `
  union WithdrawalSortType = date | amount | trxId | trxFee | netAmount

  input WithdrawalFilterInput {
    date: [String]
    amount: [Float]
    netAmount: [Float]
    trxId: String
    trxFee: [Float]
  }

  input WithdrawalTransactionInputMutation {
    amount: Float!
    accessToken: String!
    idToken: String!
    trxFee: Float!
    withdrawalBTCAddress: String!
  }
`;
